import withStyles from 'react-jss';

export const styled = withStyles({ header: { whiteSpace: 'nowrap' } });
